module.exports = __webpack_public_path__ + "img/57_24.7c4fd861.png";